import { render } from "./project.vue?vue&type=template&id=05174f72&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=05174f72&lang=less"
import "./project.vue?vue&type=style&index=1&id=05174f72&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05174f72"]])

export default __exports__